import { classNames, Icon } from '@zambezi/sdk/common'
import React, { useCallback } from 'react'

/**
 * @typedef {Object} TagLookupButtonProps
 * @property {boolean} disabled
 * @property {boolean} focused
 * @property {string} tag
 * @property {string} id
 * @property {string} inputId
 * @property {(tag:string, event: React.SyntheticEvent<Element, Event>) => void=} onTagRemove
 * @property {boolean} disabled
 * @property {import('../icons/interfaces').IconProps} removeIconProps
 */

/**
 * @type {React.FunctionComponent<TagLookupButtonProps>}
 * @param {TagLookupButtonProps} param0
 */
export default function TagLookupButton ({
  disabled,
  focused,
  id,
  inputId,
  onTagRemove,
  removeIconProps,
  tag
}) {
  const hasRemove = !disabled && !!onTagRemove
  const handleIconClick = useCallback(
    (/** @type {React.SyntheticEvent<Element, Event>} */ event) => {
      event.stopPropagation()
      onTagRemove(tag, event)
    },
    [onTagRemove]
  )
  const handleClick = useCallback(
    (/** @type {React.MouseEvent<Element>} */ event) => {
      const input = document.getElementById(inputId)
      input && input.focus()
    },
    [inputId]
  )

  return (
    <span
      role='option'
      className={classNames('zb-tag-lookup-tag zb-tag', {
        'zb-tag-with-icon-after': hasRemove,
        'zb-tag-is-focused': focused,
        'zb-tag-is-disabled': disabled || !onTagRemove
      })}
      aria-selected='true'
      aria-disabled={!hasRemove}
      onClick={handleClick}
      id={id}
    >
      {tag}
      {hasRemove ? (
        <Icon
          name='core-flyout-close'
          className='zb-tag-lookup-remove-button'
          title='Remove'
          onClick={handleIconClick}
          {...removeIconProps}
        />
      ) : null}
    </span>
  )
}
